import { deleteCallback, getCallback } from '@/utils/auth/callbacks';
import { clearLocalCognitoSession } from '@/utils/auth/clearMfaSessionSatisfaction';
import { fetchUserAttributes } from '@/utils/aws/cognito/amplifyAuth';

export async function redirectAuthenticatedUser(router, destination = '/hub') {
  try {
    await fetchUserAttributes();
    console.log('redirectAuthenticatedUser session accepted', { destination });

    const callbackPath = getCallback();
    deleteCallback();
    router.push(callbackPath || destination);
    return true;
  } catch {
    console.log('redirectAuthenticatedUser session rejected', { destination });
    await clearLocalCognitoSession();
    return false;
  }
}
